<template>
  <div class="main">
    <div class="query-item">
      <div class="search-l">
          <div style="margin-right: 30px;">
            企业名称
            <a-input class="inp ml10" placeholder="请输入" v-model:value="query.deptName"></a-input>
          </div>
          <div style="margin-right: 30px;">
            车辆识别代码
            <a-input class="inp ml10" placeholder="请输入" v-model:value="query.vin"></a-input>
          </div>
          <a-button class="ml30" @click="search" type="primary" ghost>查询</a-button>
          <a-button class="ml24" @click="reset" type="primary" ghost>重置</a-button>
      </div>
      <div class="search-r">
       <a-button v-if="store.hasPermi('testing:task:add')" class="ml30" type="primary" @click="goAddTask">+ 新增任务</a-button>
      </div>
    </div>

    <a-table :columns="columns" :row-key="(record) => record.id"
             :data-source="dataSource" size="middle" class="mt23" :pagination="pagination" :scroll="{ y: 'auto' }"
             v-autoHeight="{ extraHeight: 88, trHeight: 47 }" :headerCellStyle="{ textAlign: 'center' }">
      <template #bodyCell="{ column, record, index }">

        <template v-if="column.key === 'testingTime'">
          <div>
            {{ record.startTime }}<br>
            {{ record.endTime }}
          </div>
        </template>
        <template v-if="column.key === 'autoMileage'">
          {{ record.autoMileage?record.autoMileage:0 }}km
        </template>
        <template v-if="column.key === 'action'">
          <span>
<!--            <a class="ml10">任务详情</a>-->
<!--            <a class="ml10">测试记录</a>-->
          </span>
        </template>
      </template>
    </a-table>
    <!-- 使用ProgressDrawer组件 -->
    <ProgressDrawer
        v-model:visible="progressDrawerVisible"
        :record="currentRecord"
    />
  </div>
</template>
<script setup>
import { ref, onMounted, reactive } from "vue";
import { useRouter } from "vue-router";
import { testingTaskPages } from "@/api/testing/task";
import useUserStore from '@/store/modules/user'
import useAppStore from "@/store/modules/app";

const store = useUserStore();
const appStore = useAppStore();
const router = useRouter();

// 新增任务跳转函数
const goAddTask = () => {
  router.push('/testManage/taskAdd');
};

const columns = [
  {
    title: "企业名称",
    dataIndex: "deptName",
    key: "deptName",
    width: 150,
  },
  {
    title: "车辆识别代码",
    dataIndex: "vehicleVin",
    key: "vehicleVin",
    width: 200,
    align: "right",
  },
  {
    title: "车辆类型",
    dataIndex: "vehicleType",
    key: "vehicleType",
    width: 180,
  },
  {
    title: "测试牌照",
    dataIndex: "licenceNo",
    key: "licenceNo",
    width: 100,
    align: "right",
  },
  {
    title: "测试类型",
    dataIndex: "categoryName",
    key: "categoryName",
  },
  {
    title: "测试区域",
    dataIndex: "areaName",
    key: "areaName",
    width: 100,
  },
  {
    title: "测试路线",
    dataIndex: "routeName",
    key: "routeName",
  },
  {
    title: "测试有效期",
    key: "testingTime",
    align: "right",
  },
  // {
  //   title: "自动驾驶测试里程",
  //   key: "autoMileage",
  //   width: 150,
  //   align: "right",
  // },
  {
    title: "操作",
    key: "action",
    width: 180,
  },
];

let dataSource = ref([]);
// 新增控制更多筛选条件显示/隐藏的状态
// 移除showMoreFilters变量，使用统一风格
let query = reactive({
  deptName: '',
  status: '',
  vin: null,
  applyDateRange: null
});

const pageChange = (page, pageSize) =>{
  pagination.current = page;
  // 获取表格数据
  getData();
}

const pageSizeChange = (current, size) => {
  console.log(size);
  pagination.pageSize = size;
  // 获取表格数据
  getData();
}

const pagination = reactive({
  total: 0,
  size: "middle",
  defaultPageSize: 10,
  current: 1,
  pageSize: 10, //每页中显示10条数据
  showSizeChanger: true,
  showQuickJumper: false,
  pageSizeOptions: ["10", "20", "30"], //每页中显示的数据
  showTotal: (total) => `共有 ${total} 条数据`, //分页中显示总的数据
  onShowSizeChange: (current, pageSize) => (pagination.pageSize = pageSize), // 改变每页数量时更新显示
  onChange: pageChange, //点击页码事件
  showSizeChange: pageSizeChange,
});

const search = () => {
  pagination.current = 1
  getData();
};

const reset = () => {
  query.deptName = "";
  query.status = "";
  query.vin = null;
  query.applyDateRange = null;
  getData()
};

const getData = async () => {

  const queryData = { ...query };
  const data = {
    pageIndex: pagination.current,
    pageSize: pagination.pageSize,
    conditionMap: { ...queryData, deptId: store.deptId },
  };
  testingTaskPages(data).then((res) => {
    console.log(res);
    if (res.code === 200) {
      dataSource.value = res.data.records || [];
      pagination.total = res.data.total;
    }
  });
};

onMounted(async () => {
  await getData();
});

</script>

<style lang="less" scoped>
.inp {
  width: 13.5vw;
}

.query-item {
  display: flex;
  justify-content: space-between;

  .search-l {
    display: flex;
    flex-wrap: wrap;
  }

  .search-r {
    display: flex;
  }
}

// 移除search-filters样式，使用统一风格

/deep/.ant-input::placeholder {
  font-size: 14px;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  color: #68767E;
}

/deep/.ant-select-selector {
  background-color: #F2F4F7 !important;
  color: #68767E !important;
}

.main {
  padding: 20px;
  height: calc(100vh - 70px - 57px);
  background-color: #ffffff;
}

/* 徽章样式 */
.tab-with-badge {
  position: relative;
  display: inline-block;
}

.badge {
  position: absolute;
  top: -4px;
  right: -6px;
  min-width: 18px;
  height: 18px;
  padding: 0 6px;
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
  white-space: nowrap;
  text-align: center;
  background-color: #ff4d4f;
  color: #fff;
  border-radius: 9px;
  transform: translateX(50%);
}

.status-pending {
  color: #FA8C16;  /* 橙色 */
  font-weight: 500;
}

.status-reviewing {
  color: #1E8EF2;  /* 蓝色 */
  font-weight: 500;
}

.status-accepting {
  color: #722ED1;  /* 紫色 */
  font-weight: 500;
}

.status-group-reviewing {
  color: #F5222D;  /* 红色 */
  font-weight: 500;
}

.status-approved {
  color: #52C41A;  /* 绿色 */
  font-weight: 500;
}

.status-default {
  color: #68767E;  /* 默认灰色 */
  font-weight: 500;
}

/deep/ .ant-table-wrapper .ant-table-thead>tr>th,
.ant-table-wrapper .ant-table-thead>tr>td {
  font-size: 14px;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  color: #0A212E;
  background-color: #EFEFF5;
}

/deep/.ant-table-wrapper .ant-table:not(.ant-table-bordered) .ant-table-tbody>tr {
  color: #68767E;
}

a {
  color: #1E8EF2;
}
</style>
